import React, { useState, useEffect, useRef } from 'react';
import { _T } from "../../../../../base-react/src/Localization";
import { apis, hooks, models } from '@vote4dance/judging-sdk';
import { Alert, Button, Form, Grid, Input, Modal, notification, Select, Space, Table, Typography, Tooltip } from 'antd';
var Api = apis.Api;
var Stream = hooks.streams.Stream;
var CheckinTeamSource = models.checkins.CheckinTeamSource;
var CheckinSource = models.checkins.CheckinSource;
var TeamItem = models.teams.TeamItem;
import { CheckOutlined, CloseCircleOutlined, SignatureOutlined, UnlockOutlined } from '@ant-design/icons';
import { ButtonConfirm } from '../../../../../base-react/components/ButtonConfirm';
const { Text } = Typography;
export const CheckinTeams = (props) => {
    var _a;
    const { competition, item, disabled, checkinPhone, disableSign, markPlacement = 'bottom', phoneModalEnabled, phoneModalRequired, phoneModalMinLength = 7, phoneModalValue } = props;
    const checkinTeamSource = CheckinTeamSource(competition === null || competition === void 0 ? void 0 : competition.competition_id, item.organization_name);
    const [teams, loading] = Stream(checkinTeamSource);
    const [isLoading, setIsLoading] = useState(null);
    const [localTeams, setLocalTeams] = useState([]);
    const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
    const [phoneInput, setPhoneInput] = useState((_a = phoneModalValue !== null && phoneModalValue !== void 0 ? phoneModalValue : checkinPhone) !== null && _a !== void 0 ? _a : '');
    const [isSigning, setIsSigning] = useState(false);
    const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);
    const [reasonTeam, setReasonTeam] = useState(null);
    const [reasonValue, setReasonValue] = useState(undefined);
    const phoneInputRef = useRef(null);
    const screens = Grid.useBreakpoint();
    const isCheckinApplied = item.applied_at != null;
    const isCheckinComplete = item.checkin_time != null;
    const isXs = !screens.sm;
    useEffect(() => {
        setLocalTeams(teams ? teams.map((t) => ({ ...t, checkin_status: t.team_cancelled ? t.team_cancelled : t.checkin_status })) : []);
    }, [teams]);
    useEffect(() => {
        var _a;
        if (phoneModalValue != null || checkinPhone != null) {
            setPhoneInput((_a = phoneModalValue !== null && phoneModalValue !== void 0 ? phoneModalValue : checkinPhone) !== null && _a !== void 0 ? _a : '');
        }
    }, [phoneModalValue, checkinPhone, item.organization_name]);
    useEffect(() => {
        if (!isPhoneModalOpen) {
            return;
        }
        const timer = window.setTimeout(() => {
            var _a;
            (_a = phoneInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 0);
        return () => window.clearTimeout(timer);
    }, [isPhoneModalOpen]);
    const updateCheckinStatus = async (team, status) => {
        setIsLoading(team.team_id);
        try {
            await Api.update(`${checkinTeamSource.url}/${team.team_id}`, {
                ...item,
                checkin_status: status
            });
            setLocalTeams(prev => prev.map(t => t.team_id === team.team_id ? { ...t, checkin_status: status } : t));
        }
        catch (err) {
            notification.error({ message: err.message });
        }
        setIsLoading(null);
    };
    const signToggleCheckin = async (command, phone, done) => {
        const payload = { teams: localTeams };
        if (command === 'confirm' && phone != null) {
            payload.checkin_phone = phone;
        }
        else if (command === 'confirm' && checkinPhone != null) {
            payload.checkin_phone = checkinPhone;
        }
        await Api.call(`${CheckinSource(competition === null || competition === void 0 ? void 0 : competition.competition_id).url}/${item.organization_name}`, command, payload)
            .then(() => {
            notification.success({
                message: _T(`common.apply.success`, { name: _T('checkin.sign').toLowerCase() })
            });
        })
            .catch((err) => {
            notification.error({
                message: err.message
            });
        });
        if (done) {
            done();
        }
    };
    const markAllParticipating = (done) => {
        if (teams) {
            Promise.all(teams.filter((team) => team.team_cancelled == 0).map(team => updateCheckinStatus(team, 0)))
                .then(() => done())
                .catch(error => {
                console.error("Error updating checkin status:", error);
                done();
            });
        }
        else {
            done();
        }
    };
    const enableSign = localTeams.every(a => a.checkin_status != null);
    const isSignDisabled = !!disableSign || isCheckinApplied;
    const isPhoneRequired = !!phoneModalRequired;
    const isPhoneValid = !isPhoneRequired || phoneInput.trim().length >= phoneModalMinLength;
    const handleSignClick = () => {
        if (phoneModalEnabled) {
            setIsPhoneModalOpen(true);
            return;
        }
    };
    const handlePhoneModalOk = async () => {
        if (!isPhoneValid) {
            return;
        }
        setIsSigning(true);
        await signToggleCheckin('confirm', phoneInput);
        setIsSigning(false);
        setIsPhoneModalOpen(false);
    };
    const openReasonModal = (team) => {
        var _a;
        setReasonTeam(team);
        setReasonValue((_a = team.checkin_status) !== null && _a !== void 0 ? _a : undefined);
        setIsReasonModalOpen(true);
    };
    const handleReasonModalOk = async () => {
        if (!reasonTeam) {
            return;
        }
        await updateCheckinStatus(reasonTeam, reasonValue);
        setIsReasonModalOpen(false);
    };
    const renderSignAction = () => (React.createElement(React.Fragment, null, item.checkin_time ?
        React.createElement(ButtonConfirm, { title: _T('common.unlock'), description: _T('common.reset.content', { name: _T('checkin.sign').toLowerCase() }), onConfirm: done => signToggleCheckin('reset', undefined, done), buttonProps: {
                danger: true,
                icon: React.createElement(UnlockOutlined, null),
                disabled: disabled || isCheckinApplied
            } })
        :
            phoneModalEnabled ? (React.createElement(Button, { type: "primary", icon: React.createElement(SignatureOutlined, null), disabled: !enableSign || isSignDisabled, onClick: handleSignClick }, _T('checkin.sign'))) : (React.createElement(ButtonConfirm, { title: _T('checkin.sign'), description: _T('common.confirm'), onConfirm: done => signToggleCheckin('confirm', undefined, done), buttonProps: {
                    type: 'primary',
                    disabled: !enableSign || isSignDisabled,
                    icon: React.createElement(SignatureOutlined, null)
                } }))));
    const renderMarkAction = () => (React.createElement("div", { style: { marginBottom: 16 } },
        React.createElement(ButtonConfirm, { title: _T('checkin.mark'), description: _T('common.confirm'), onConfirm: done => markAllParticipating(done), buttonProps: {
                disabled: disabled || isCheckinApplied || isCheckinComplete
            } })));
    const columns = [
        {
            title: _T('team.details.team_start_number.short'),
            dataIndex: 'team_start_number'
        },
        {
            dataIndex: "team_name",
            title: _T('team.details.team_name.label'),
            render: (text, item) => React.createElement(Text, { type: item.checkin_status == null ? undefined : item.checkin_status == 0 ? "success" : "danger" }, TeamItem.getFullName(item))
        },
        {
            dataIndex: "team_class",
            title: _T('class.title')
        },
        {
            title: _T('checkin.status.label'),
            dataIndex: "checkin_status",
            render: (text, item) => (React.createElement(Space, null,
                React.createElement(Tooltip, { title: isXs ? _T('team.details.team_cancelled.reason.0') : undefined },
                    React.createElement(Button, { type: item.checkin_status === 0 ? "primary" : "default", icon: isXs ? React.createElement(CheckOutlined, null) : undefined, disabled: disabled || isCheckinApplied || isCheckinComplete || item.team_cancelled > 0, onClick: () => updateCheckinStatus(item, item.checkin_status === 0 ? undefined : 0), "aria-label": _T('team.details.team_cancelled.reason.0') }, !isXs && _T('team.details.team_cancelled.reason.0'))),
                React.createElement(Tooltip, { title: isXs ? _T('team.details.team_cancelled.label') : undefined },
                    React.createElement(Button, { type: item.checkin_status && item.checkin_status > 0 ? "primary" : "default", danger: !!(item.checkin_status && item.checkin_status > 0), icon: isXs ? React.createElement(CloseCircleOutlined, null) : undefined, disabled: disabled || isCheckinApplied || isCheckinComplete || item.team_cancelled > 0, onClick: () => openReasonModal(item), "aria-label": _T('team.details.team_cancelled.label') }, !isXs && _T('team.details.team_cancelled.label')))))
        },
    ].filter(column => Object.keys(column).length > 0);
    return (React.createElement(React.Fragment, null,
        markPlacement === 'top' && renderMarkAction(),
        React.createElement(Table, { columns: columns, loading: loading, dataSource: localTeams, pagination: false, footer: () => renderSignAction(), size: "small", rowKey: "team_id" }),
        React.createElement(Modal, { open: !!phoneModalEnabled && isPhoneModalOpen, onOk: handlePhoneModalOk, onCancel: () => setIsPhoneModalOpen(false), okText: _T('checkin.sign'), confirmLoading: isSigning, okButtonProps: { disabled: !isPhoneValid || isSignDisabled || !enableSign } },
            React.createElement(Form, { layout: "vertical" },
                React.createElement(Form.Item, { label: _T('checkin.phone'), required: isPhoneRequired, validateStatus: !isPhoneValid ? 'error' : undefined, help: !isPhoneValid ? _T('common.required') : undefined },
                    React.createElement(Input, { ref: phoneInputRef, value: phoneInput, onChange: e => setPhoneInput(e.target.value), onPressEnter: () => {
                            if (!isPhoneValid || isSignDisabled || !enableSign || isSigning) {
                                return;
                            }
                            void handlePhoneModalOk();
                        }, placeholder: _T('checkin.phone') })),
                React.createElement(Alert, { type: "warning", showIcon: true, title: _T('common.confirm'), description: _T('checkin.submit-disclaimer') }))),
        React.createElement(Modal, { open: isReasonModalOpen, onOk: handleReasonModalOk, onCancel: () => setIsReasonModalOpen(false), okText: _T('common.ok'), okButtonProps: { disabled: reasonValue == null } },
            React.createElement(Form, { layout: "vertical" },
                React.createElement(Form.Item, { label: _T('team.details.team_cancelled.label') },
                    React.createElement(Select, { value: reasonValue, onChange: value => setReasonValue(value), placeholder: _T('team.details.team_cancelled.placeholder') }, [0, 1, 2, 3, 4, 5].map((reason) => (React.createElement(Select.Option, { value: reason, key: reason }, _T('team.details.team_cancelled.reason.' + reason.toString()))))))))));
};
